import React, { createContext, useContext } from "react";
import { useWishlist } from "../hooks/useWishlist.js";

interface WishlistContextType {
  wishlistItems: Set<string>;
  isInWishlist: (
    animalId: string,
    animalType: "cao" | "gato" | "ninhada",
  ) => boolean;
  addToWishlist: (
    animalId: string,
    animalType: "cao" | "gato" | "ninhada",
    animalName?: string,
  ) => Promise<{ success: boolean; likes?: number; wishlistItem?: any }>;
  removeFromWishlist: (
    animalId: string,
    animalType: "cao" | "gato" | "ninhada",
    animalName?: string,
  ) => Promise<{ success: boolean; likes?: number }>;
  toggleWishlist: (
    animalId: string,
    animalType: "cao" | "gato" | "ninhada",
    animalName?: string,
  ) => Promise<{ success: boolean; likes?: number; wishlistItem?: any }>;
  loading: boolean;
  fetchUserWishlist: () => Promise<void>;
  clearWishlist: () => void;
}

const WishlistContext = createContext<WishlistContextType | undefined>(
  undefined,
);

export const useWishlistContext = () => {
  const context = useContext(WishlistContext);
  if (!context) {
    throw new Error(
      "useWishlistContext must be used within a WishlistProvider",
    );
  }
  return context;
};

interface WishlistProviderProps {
  children: React.ReactNode;
}

export const WishlistProvider: React.FC<WishlistProviderProps> = ({
  children,
}) => {
  const wishlistHook = useWishlist();

  return (
    <WishlistContext.Provider value={wishlistHook}>
      {children}
    </WishlistContext.Provider>
  );
};
